module.exports = __webpack_public_path__ + "img/divide-no-item-icon.bb4573b9.svg";